import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { safelyDetectChanges } from 'src/app/common/app.helpers';
import AppSettings from 'src/app/common/app.settings';
import AppValues from 'src/app/common/app.values';
import { UserInfo } from 'src/app/interfaces';
import { AccountStatus } from 'src/app/swagger-api';
import { createLink } from '../../profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { ChatMessage } from '../interfaces/chat-model.interface';

@Component({
  selector: 'app-message-block',
  templateUrl: './message-block.component.html',
  styleUrls: ['./message-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageBlockComponent implements DoCheck {
  @Input({ required: true }) public message: ChatMessage;
  @Input({ required: true }) public currentUserId: string;
  @Input({ required: true }) public participants: UserInfo[] | null;
  @Input({ required: true }) public index: number;

  @Output() public editMessage: EventEmitter<ChatMessage> = new EventEmitter<ChatMessage>();
  @Output() public removeMessage: EventEmitter<ChatMessage> = new EventEmitter<ChatMessage>();

  public isDropdownOpen = false;

  public readonly DEFAULT_PROFILE_IMAGE: string = AppSettings.DEFAULT_USER_IMAGE;
  public readonly DATE_TIME_FORMAT_SHORT: string = AppValues.DATE_TIME_FORMAT_SHORT;

  public readonly DELETED: AccountStatus = AccountStatus.DELETED;

  private changeDetector = inject(ChangeDetectorRef);

  public ngDoCheck(): void {
    this.changeDetector.markForCheck();
  }

  public get isSentByCurrentUser(): boolean {
    return this.message.sender.userId === this.currentUserId;
  }

  public get isSenderDeleted(): boolean {
    return this.message.sender.userStatus === AccountStatus.DELETED;
  }

  public getLink(user: UserInfo): string {
    return createLink(user.userStatus, user.userId);
  }

  public onEditMessage(): void {
    this.editMessage.emit(this.message);
  }

  public onRemoveMessage(): void {
    this.removeMessage.emit(this.message);
  }

  public setDropDownOpenStatus(status: boolean): void {
    this.isDropdownOpen = status;
    safelyDetectChanges(this.changeDetector);
  }
}
